import { render, staticRenderFns } from "./FilterAttentions.vue?vue&type=template&id=26d12181&scoped=true&"
import script from "./FilterAttentions.vue?vue&type=script&lang=js&"
export * from "./FilterAttentions.vue?vue&type=script&lang=js&"
import style0 from "./FilterAttentions.vue?vue&type=style&index=0&id=26d12181&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d12181",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('26d12181', component.options)
    } else {
      api.reload('26d12181', component.options)
    }
    module.hot.accept("./FilterAttentions.vue?vue&type=template&id=26d12181&scoped=true&", function () {
      api.rerender('26d12181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/filter_attentions/FilterAttentions.vue"
export default component.exports